import React from 'react';
import { z } from 'zod';
import { SelectOption } from 'global';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { CurrencyInputField, RadioGroupField, SelectField } from 'components/form';
import { FinanceStructureSchema } from '../model';
import { existingProgramTypeOptions } from '../constants';
import { determineMaxApprovalAmountNotification } from '../../../lib';

interface Props {
  financeAmount: number;
  maxApprovalAmount: number;
  submissionsOptions: SelectOption[];
  isSubmissionsLoading?: boolean;
  submissions: Record<string, any>;
}

export const InitializeWorkflow = ({
  submissions,
  financeAmount,
  maxApprovalAmount,
  submissionsOptions,
  isSubmissionsLoading = false,
}: Props) => {
  const { control, setValue } = useFormContext<z.infer<typeof FinanceStructureSchema>>();

  return (
    <>
      <Box className="row">
        <RadioGroupField
          row
          control={control}
          className="flexed-radio"
          label="Use Saved Program?"
          options={existingProgramTypeOptions}
          name="financeQuote.createProposalWithExistingProgram"
        />
      </Box>

      <SelectField
        control={control}
        label="Select Submission"
        options={submissionsOptions}
        isLoading={isSubmissionsLoading}
        name="financeQuote.selectedSubmissionId"
        extraAction={selectedId => {
          const submission = submissions[selectedId as string] ?? null;
          setValue('financeQuote.maxApprovalAmount', submission?.approvedAmount);
        }}
      />

      <CurrencyInputField
        control={control}
        label="Max Approval Amount"
        name="financeQuote.maxApprovalAmount"
        notify={determineMaxApprovalAmountNotification(financeAmount, maxApprovalAmount)}
        textFieldProps={{
          placeholder: 'Enter amount...',
        }}
      />
    </>
  );
};
